import { Component, computed, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { FirebaseCodeErrorService } from 'src/app/services/firebase-code-error.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.css'],
    standalone: false
})
export class RecoverPasswordComponent {
  private _authService = inject(AuthService);
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private _firebaseError = inject(FirebaseCodeErrorService);
  private _loadingService = inject(LoadingService);

  // estado
  error = signal('');
  loading = computed(() => this._loadingService.isLoading());

  // form tipado
  recuperarUsuario = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
  });

  async recuperar() {
    // Evita doble submit si ya está cargando
    if (this.loading() || this.recuperarUsuario.pending) return;

    // Dispara validaciones en todos los campos
    this.recuperarUsuario.markAllAsTouched();
    if (this.recuperarUsuario.invalid) {
      this.error.set('Ingrese un email válido');
      return;
    }

    const raw = this.recuperarUsuario.getRawValue();
    const email = raw.email.trim().toLowerCase(); // ✅ normalizar

    try {
      this.error.set('');
      this.recuperarUsuario.disable({ emitEvent: false }); // ✅ bloquear form
      await this._loadingService.run(async () => {
        await this._authService.recoverPassword(email);
      });
      this._firebaseError.showSuccess('Te enviamos un email con instrucciones para restablecer tu contraseña.', 5000);
      await  this.router.navigateByUrl('/sign-in');
    } catch (err: any) {
      const code = this._firebaseError.extractCode(err);
      const msg = this._firebaseError.codeError(code) || (err?.message ?? 'Ocurrió un error al recuperar contraseña');
      this.error.set(msg);
      console.error(err);
    } finally {
      this.recuperarUsuario.enable({ emitEvent: false }); // ✅ re-habilitar form
    }
  }
}
